module.exports = __webpack_public_path__ + "static/media/icon_aa.a9f682eb.svg";